<div class="icn-radio-button">
  <input
    type="radio"
    name="radiogroup"
    id="timeBasedRadioId"
    [value]="1"
    [(ngModel)]="rule.recurringType"
  />
  <label for="timeBasedRadioId"
    >Time Based (The media will be played in intervals)</label
  ><br />

  <input
    type="radio"
    name="radiogroup"
    id="videoBasedRadioId"
    [value]="2"
    [(ngModel)]="rule.recurringType"
  />
  <label for="videoBasedRadioId"
    >Video based (The media will be added to selected videos)</label
  ><br />

  <input
    type="radio"
    name="radiogroup"
    id="alwaysBasedRadioId"
    [value]="3"
    [ngModel]="rule.recurringType"
  />
  <label for="alwaysBasedRadioId"
    >Always show (The media will be always visible)</label
  ><br />
</div>
